import React from "react"
import LocalShippingIcon from "@mui/icons-material/LocalShipping"
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle"

// Alto fijo del navbar de Logística: el drawer lateral arranca debajo
export const navbarHeight = 64

// Pantallas de la sección Logística: las usan las tarjetas de LogisticaHome y el drawer lateral
export const logisticaItems = [
    {
        icon: <LocalShippingIcon />,
        description: "Armado de planilla de reparto",
        path: "logistica/planilla-reparto",
    },
    {
        icon: <AirportShuttleIcon />,
        description: "Transportes Patentes",
        path: "logistica/transportes",
    },
]
